var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowleftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8006 11.9966C16.8006 12.6966 16.5306 13.3966 16.0006 13.9266L9.48062 20.4466C9.19062 20.7366 8.71062 20.7366 8.42063 20.4466C8.13063 20.1566 8.13063 19.6766 8.42063 19.3866L14.9406 12.8666C15.4206 12.3866 15.4206 11.6066 14.9406 11.1266L8.42063 4.60656C8.13063 4.31656 8.13063 3.83656 8.42063 3.54656C8.71062 3.25656 9.19062 3.25656 9.48062 3.54656L16.0006 10.0666C16.5306 10.5966 16.8006 11.2966 16.8006 11.9966Z",
    fill: "#23252A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleftIcon);
export default __webpack_public_path__ + "static/media/arrowleftIcon.0072bfa6301c93d4e79fdebb05e59d94.svg";
export { ForwardRef as ReactComponent };